import React, { useRef, useState, useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import PropTypes from "prop-types"
import { gsap } from "gsap"

import SubpageLayout from "layouts/SubpageLayout"
import { Loader } from "ui"
import { SEO, Footer } from "components"
import ContactContent from "./ContactContent"

const query = graphql`
  {
    allWpPage(filter: { contact: { contactLang: { regex: "/ES|EN/" } } }) {
      edges {
        node {
          title
          contact {
            title
            contactLang
            addressLabel
            address
            contactDetails {
              phone
              emailNo1
              emailNo2
              emailNo3
              emailNo4
            }
            contactForm {
              buttonName
              emailLabel
              messageLabel
              fieldRequired
              invalidEmail
              messageMinCharacters
              messageSentFailed
              sentMessage
              placeholderEmail
              placeholderMessage
            }
          }
        }
      }
    }
  }
`

const ContactTemplate = ({ location, lang }) => {
  const { allWpPage: { edges: languageDataVersions } } = useStaticQuery(query) // eslint-disable-line
  const [pageContent, setPageContent] = useState(null)
  const [loading, setLoading] = useState(true)

  const contactSectionRef = useRef(null)

  useEffect(() => {
    if (loading) return

    const section = contactSectionRef.current
    const title = section.querySelector("#contactTitle")
    const content = section.querySelector("#contactContent")

    const tl = gsap.timeline()

    tl.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0.25 })
      .fromTo(
        title,
        { y: "+=50", opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.25,
        }
      )
      .fromTo(
        content,
        { y: "+=50", opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.25,
        }
      )
  }, [contactSectionRef, loading])

  useEffect(() => {
    const { node } = languageDataVersions.find(
      ({ node: { contact } }) => contact.contactLang === lang
    )

    setPageContent({ contact: node?.contact, title: node?.title })

    const id = setTimeout(() => setLoading(false), 500)
    return () => clearTimeout(id)
  }, [])

  return (
    <>
      <SEO title={pageContent?.title || ""} />
      <SubpageLayout path={location.pathname}>
        {loading ? (
          <Loader />
        ) : (
          <>
            <ContactContent
              title={pageContent?.contact?.title || ""}
              contactForm={pageContent?.contact?.contactForm}
              contactDetails={pageContent?.contact?.contactDetails}
              address={{
                label: pageContent?.contact?.addressLabel,
                content: parse(pageContent?.contact?.address || "", {
                  trim: true,
                }),
              }}
              _ref={contactSectionRef}
            />
            <Footer />
          </>
        )}
      </SubpageLayout>
    </>
  )
}

ContactTemplate.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
}

export default ContactTemplate
